import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/percentage-calculator',
  component: () => import('../../routes/PercentageCalculator.svelte'),
  card: {
    id: 'percentage-calculator',
    title: 'Percentage Calculator',
    description: 'Calculate percentages in three ways: find the percentage of a number, find what percent one number is of another, or find the whole from a percentage.',
    icon: 'percent',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/percentage-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Percentage Calculator – Find % of Any Number Free',
    description: 'Free percentage calculator to find what percent one number is of another, calculate X% of Y, or find the whole number from a percentage. Works in any direction.',
  },
};

export default meta;
